import gql from 'graphql-tag'

//---------------------------- HomePage Queries ---------------------------------

export const homepageQuery = gql`
query homeQuery($alias : JSON, $lang: String) {
  homepages (sort: "displayPosition:asc", where : { alias : $alias }, locale: $lang) {
    id
    speech    
    menuName
    locale 
    alias    
    desc
    pageType{
      ... on ComponentHomepageNavigation{
        __typename
        pathName
        pageHeader
      }
      ... on ComponentHomepageDialogBox{
        __typename
        type
        textList
      }
    }
    menuIcon{
      id
      url
    }
  }
}
`

//---------------------------- Faq Page Queries ---------------------------------

export const faqCategoryQuery = gql`
query faqCategoryQuery($lang: String, $location: String, $category: String) {
  faqCategories(sort: "displayOrder:asc", locale: $lang, where : { courtLocationCode_contains : $location, categoryName : $category}) {
    id
    categoryName
    displayType
    displayOrder
    locale
  }
}
`

export const faqQuery = gql`
query faqQuery($lang: String) {
  faqs (start: 0, locale: $lang) {
    id
    category
    locale
    showMap
    mapName
    showform
    formName
    showQr
    qrDetails
    linkID
    question
    answer
  }
}
`

export const faqQuery2 = gql`
query faqQuery($lang: String) {
  faqs (start: 100, locale: $lang) {
    id
    category
    locale
    mapName
    showform
    formName
    showQr
    qrDetails
    linkID
    question
    answer
  }
}
`
//---------------------------- Map Page Queries ---------------------------------

export const floorQuery = gql`
query floorQuery($lang: String, $location: String) {
  floors (sort : "floorNumber:ASC", locale: $lang, where : { kioskLocationCode_contains: $location }){ 
    id
    floorName
    floorNumber
    speech
    defaultLocation
    locale
    floorImage {
      id
      url
    }
  }
}
`

export const mapQuery = gql`
query mapQuery($lang: String,  $location: String) {
  maps(sort: "mapFloor:ASC", locale: $lang, where : { kioskLocationCode_contains: $location }){
    id
    mapName
    mapFloor
    speech
    locale
    displayPosition
    mapImage {
      id
      url
    }
  }
}
`

//---------------------------- Form Page Queries ---------------------------------


export const formCategoryQuery = gql`
query formCategoryQuery ($lang: String) {
  formCategories(sort: "id:asc", locale: $lang) {
    id
    categoryName
    categoryType
    locale
  }
}
`

export const allFormQuery = gql`
query formQuery ($lang: String) {
  allForms(start: 0, sort: "id:asc", locale: $lang) {
    id
    formName
    formCategory
    pdfUrl
    locale
    formPdf{
      id
      url
    }
  }
}
`
